<template>
  <div class="modal-wrapper">
    <!-- モーダル背景オーバーレイ -->
    <div class="background-menu" @click="cancel" v-if="isShowModal"></div>
    <transition name="right">
      <div v-if="isShowModal" class="email-history-container" style="position: absolute; top: 0; right: 0; height: 100%; width: 54%; min-width: 1025px; background: #FEFEFE; padding: 16px; z-index: 201; overflow: auto;">
        <div class="modal-header">
          <h2 class="modal-title">メール送受信履歴（{{ selectEmailSeeker.name }}）</h2>
          <button class="close-button" @click="cancel">
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <article class="container">
          <!-- メール送受信履歴 -->
          <section class="main-section" v-if="sendedEmailList.length">
            <p>メール送受信履歴</p>
            <article class="table-wrapper">
              <!-- テーブル一覧 -->
              <EmailLogTable :sendedEmailList="sendedEmailList"
                :user="user"
                @clickEmailDetailButton="clickEmailDetailButton"/>
              <!-- メール詳細 -->
              <EmailDetail v-if="isClickEmailDetailButton"
                :selectSended="selectSended"
                :enablePrev="emailDetailStatus.enablePrev"
                :enableNext="emailDetailStatus.enableNext"
                @clickPrev="clickPrev"
                @clickNext="clickNext"
                @clickCloseBtn="clickCloseBtn"/>
            </article>
          </section>
          <!-- 送付済みメール情報 メール未送付の場合 -->
          <section v-if="sendedEmailList.length === 0">
            <p>この訪問者へはまだメールをお送りしておりません。</p>
          </section>
        </article>
      </div>
    </transition>
  </div>
</template>

<script>
import EmailLogTable from '@/components/molecules/tables/EmailLogTable'
import EmailDetail from '@/components/organisms/articles/EmailDetail'

export default {
  components: {
    EmailLogTable,
    EmailDetail
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    },
    selectEmailSeeker: {
      type: Object,
      required: false,
      default: () => ({})
    },
    sendedEmailList: {
      type: Array,
      required: false,
      default: () => []
    },
    user: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      isClickEmailDetailButton: false,
      selectSended: {},
      emailDetailStatus: {enablePrev: true, enableNext: false}
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
      this.isClickEmailDetailButton = false
    },
    selectEmailDetailIndex (idx) {
      if (idx < 0 || idx >= this.sendedEmailList.length) return
      this.selectSended = this.sendedEmailList[idx]
      this.emailDetailStatus.enableNext = (idx != 0)
      this.emailDetailStatus.enablePrev = (idx != this.sendedEmailList.length-1)
    },
    clickEmailDetailButton (sended) {
      this.isClickEmailDetailButton = true
      const idx = this.sendedEmailList.findIndex((item) => item == sended)
      this.selectEmailDetailIndex(idx)
    },
    clickPrev () {
      const idx = this.sendedEmailList.findIndex((item) => item == this.selectSended)
      this.selectEmailDetailIndex(idx+1)
    },
    clickNext () {
      const idx = this.sendedEmailList.findIndex((item) => item == this.selectSended)
      this.selectEmailDetailIndex(idx-1)
    },
    clickCloseBtn () {
      this.isClickEmailDetailButton = false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    
    .modal-title {
      font-size: 1.5rem;
      font-weight: 600;
      margin: 0;
    }
    
    .close-button {
      background: none;
      border: none;
      font-size: 1.5rem;
      cursor: pointer;
      color: #666;
      padding: 4px;
      border-radius: 4px;
      
      &:hover {
        background-color: #f0f0f0;
        color: #333;
      }
    }
  }
  
  .container {
    padding: 8px;
    height: calc(100vh - 100px);
    display: flex;
    align-items: center;
    overflow: auto;
    section {
      width: 100%;
    }
  }
  .table-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    position: relative;
    padding: 8px;
    overflow-x: auto;
  }
  .main-section {
    height: 100%;
  }
}

/* Background overlay */
.background-menu {
  height: 100%; 
  width: 100%; 
  background: rgba(0, 0, 0, 0.5); 
  position: absolute; 
  z-index: 200; 
  top: 0;
}

/* Right slide transition */
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalEmailHistory.vue